import { Outlet, Navigate } from '@/util/react-router-dom';
import { useCurrentUser } from '@/contexts/current-user-context';

export function PreAuthOutlet() {
  const { user } = useCurrentUser();
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}
